// extracted by mini-css-extract-plugin
module.exports = {"main":"market_main__xwGN8","search":"market_search__N_Wp_","topSearch":"market_topSearch__vjKqt","content":"market_content__GHX1E"};